const _sm = "0px 2px 2px rgba(0, 0, 0, 0.05)"
const _lg = "0px 1px 5px rgba(0, 0, 0, 0.25)"
const config = { "sm": _sm, "lg": _lg,  }
export { config as default, _sm, _lg }